import { render, staticRenderFns } from "./Larosate.vue?vue&type=template&id=6fd745b8&scoped=true&"
import script from "./Larosate.vue?vue&type=script&lang=js&"
export * from "./Larosate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd745b8",
  null
  
)

export default component.exports